import CheckoutSummary from "./CheckoutSummary";

export default CheckoutSummary;
